import Grid2 from '@mui/material/Unstable_Grid2';
import { GRID_CONTAINER_CONFIG } from '../consts';
import { CardInformationColumn } from './components/CardInformationColumn';
import { getPhysicalCardStatus } from 'src/modules/Flexflow/utils/getPhysicalCardStatus';
import { type CardDetailsGroup } from '../../types';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';
import { useGetNovationUrlQuery } from 'src/shared/api/flexflow';

type CardInformationSectionProps = {
  data?: CardDetailsGroup;
};

export const CardInformationSection = ({ data }: CardInformationSectionProps) => {
  const physicalCardStatus = getPhysicalCardStatus(data);
  const { t } = useTranslation(['flexflow']);
  const {
    values: { id, card }
  } = useFormState();
  const { data: novationDetails } = useGetNovationUrlQuery({ employeeId: id }, { skip: !card });

  const cardsData = {
    virtual: {
      title: t('virtual card'),
      status: data?.status,
      createdAt: data?.createdAt,
      cardToken: data?.cardToken,
      novationDetails
    },
    physical: {
      title: t('physical card'),
      status: physicalCardStatus,
      createdAt: data?.physicalCard?.requestedAt
    }
  };

  return (
    <Grid2 container {...GRID_CONTAINER_CONFIG}>
      <CardInformationColumn data={cardsData?.virtual} />
      <CardInformationColumn data={cardsData?.physical} />
    </Grid2>
  );
};
